// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--CqUDB","content":"dd31006766--content--Z0RYx","description":"dd31006766--description--D27gR","image":"dd31006766--image--BBK9Z"};